import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, TOKEN_KEY, getToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!getToken()) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    clearToken();
    (remember ? localStorage : sessionStorage).setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export const homeFor = (u) => (u?.role === "tecnico" && !u?.admin_power ? "/tecnico" : "/admin");
export const isAdmin = (u) => u?.role === "admin" || !!u?.admin_power;

export function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-sm text-slate-500" data-testid="auth-loading">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role) && !(roles.includes("admin") && isAdmin(user))) return <Navigate to={homeFor(user)} replace />;
  return children;
}
